export default "__VITE_ASSET__CBVyOqtB__"